import PartnershipPage from './PartnershipPage';

export default PartnershipPage;
